import React, { useEffect, useState } from 'react'
import SideBarPage from '@views/SideBarPage'
import SideBar from '@components/SideBar'
import {
  COLORS,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
  IMAGE_SIZES,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Loader from '@components/Loader'
import Image from '@components/Image'
import Divider from '@components/Divider'
import ContentHeader from '@components/ContentHeader'
import SectionRenderer from '@components/SectionRenderer'
import { getBookImageUrl } from '@helpers/book'
import { useInstructionBook } from '@hooks/useInstructionBook'
import Icon from '@components/Icon'

const Help = () => {
  const { book, error } = useInstructionBook()
  const [currentSection, setCurrentSection] = useState(undefined)

  useEffect(() => {
    if (book?.sections?.length > 0) {
      setCurrentSection(book.sections[0])
    }
  }, [book])

  return (
    <SideBarPage>
      {/* sidebar */}
      <SideBar>
        {!book && !error && <Loader />}
        {error && <p>Något blev fel när boken skulle laddas</p>}

        {!error && book && book?.subject && (
          <div>
            <Divider size={DIVIDER_SIZE.SMALL} />

            <div className={'flex'}>
              <div className={'h-20 w-20 mr-4'}>
                <Image
                  size={IMAGE_SIZES.MEDIUM}
                  imageUrl={getBookImageUrl(book)}
                />
              </div>
              <div className={'flex flex-col'}>
                <div className={'flex items-center text-secondaryGreen'}>
                  <Icon icon={'Book'} />
                  <span className='ml-2'>Guide</span>
                </div>

                <Heading
                  headingLevel={HEADING_TYPE.H2}
                  size={TEXT_SIZES.BASE}
                  color={COLORS.WHITE.TEXT}
                >
                  {book?.name}
                </Heading>
              </div>
            </div>

            <Divider size={DIVIDER_SIZE.SMALL} />

            <Divider
              size={DIVIDER_SIZE.LINE}
              color={COLORS.LIGHT_DARK_GREY.BORDER}
              line
            />

            <SideBar.SectionList
              subject={book.subject}
              sections={book?.sections}
              currentSection={currentSection}
              onClick={(section) => setCurrentSection(section)}
            />
          </div>
        )}

      </SideBar>

      {/* main area */}
      <div>
        {!book && !error && <Loader />}
        {error && <Text>Nåt gick fel när vi skulle ladda boken</Text>}

        {!error && book && currentSection && currentSection.subject && (
          <>
            <ContentHeader hideButtons={true} />
            <SectionRenderer
              section={currentSection}
              hideSubject
            />
          </>
        )}
      </div>
    </SideBarPage>
  )
}

export default Help
